{
  "verified": "Verificato",
  "iv_status": {
    "verified": "Verificato",
    "pending": "In attesa",
    "attention": "Attenzione"
  },
  "zoom_in": "Ingrandimento",
  "zoom_out": "Zoom out",
  "rotate": "Ruotare",
  "close": "Chiudi",
  "esc_to_close": "Premere ESC per chiudere",
  "play": "Gioco",
  "pause": "Pausa",
  "mute": "Muto",
  "unmute": "Disattivare l'audio",
  "enter_full_screen": "Entrare a schermo intero",
  "exit_full_screen": "Uscita dallo schermo intero",
  "video_not_supported": "Il vostro browser non supporta il tag video.",
  "skip_forward": "Salto in avanti",
  "skip_backward": "Salto all'indietro",
  "loading": "Caricamento",
  "loading_video": "Caricamento video...",
  "loading_data_description": "Si prega di attendere mentre carichiamo i dati. Non ci vorrà molto.",
  "no_results": "Nessun risultato",
  "nothing_found": "Nessun risultato trovato",
  "save_changes": "Salva le modifiche",
  "saved_exclamation": "Salvati!",
  "saving": "Risparmio",
  "validating": "Convalida",
  "error": "Errore",
  "optional": "Opzionale",
  "search_property": "Ricerca proprietà",
  "reset_search": "Reimposta ricerca",
  "no_items_to_show": "Nessun elemento da mostrare",
  "showing_range_of_total_items": "Mostra {{range}} di {{total}} elementi",
  "rows_per_page": "Righe per pagina",
  "page_of_pages": "Pagina {{page}} di {{pages}}",
  "go_to_first_page": "Vai alla prima pagina",
  "go_to_previous_page": "Vai alla pagina precedente",
  "go_to_next_page": "Vai alla pagina successiva",
  "go_to_last_page": "Vai all'ultima pagina",
  "sort_in_asc": "Ordinamento in ordine crescente",
  "sort_in_desc": "Ordina in ordine decrescente",
  "clear_sorting": "Smistamento chiaro",
  "sort_a_z": "Ordinamento A → Z",
  "sort_z_a": "Ordinamento Z → A",
  "reach_us_at_email": "Contatta l'assistenza all'indirizzo support@chekin.com",
  "please_wait": "Attendere prego",
  "feature_coming_soon": "Prossimo",
  "feature_coming_soon_description": "Questa funzione è attualmente in fase di sviluppo e sarà disponibile presto. Manteniti aggiornato per le ultime notizie!",
  "beta": "Beta",
  "download_all": "Scarica tutto",
  "entry_forms": "Moduli di iscrizione",
  "tutorial": "Tutorial",
  "liveness_video": "Video di prova di vita",
  "reviews": "Recensioni",
  "learn_more": "Per saperne di più",
  "this_cannot_be_reverted": "This cannot be reverted",
  "delete": "Delete",
  "cancel": "Cancel",
  "you_have_made_changes": "You have made changes",
  "would_you_like_to_save_them": "Would you like to save them?",
  "save": "Save",
  "dont_save": "Don't save",
  "copied_exclamation": "Copiato!",
  "search_placeholder": "Ricerca...",
  "type_to_search": "Digitare per cercare...",
  "loading_more": "Caricamento...",
  "no_options": "Nessuna opzione",
  "select_option": "Selezionare l'opzione",
  "clear_all": "Cancella tutto",
  "remove_item": "Rimuovere {{label}}",
  "upload_file": "Caricare il file",
  "download_attachment": "Scarica l'allegato",
  "remove_file": "Rimuovere il file",
  "open_calendar": "Calendario aperto",
  "clear_dates": "Cancella le date",
  "select_dates": "Selezionare le date",
  "pick_date_range": "Scegliere un intervallo di date",
  "from": "Da",
  "to": "A",
  "pick_month": "Scegliere un mese",
  "pick_date": "Scegliere una data",
  "month": "Mese",
  "day": "Giorno",
  "year": "Anno",
  "done": "Fatto",
  "wrong_period_of_dates": "Il periodo selezionato non è valido",
  "date_range_max_days_error_one": "L'intervallo non può essere superiore a {{count}} giorno",
  "date_range_max_days_error_other": "L'intervallo non può superare {{count}} giorni",
  "date_range_min_days_error_one": "L'intervallo deve essere di almeno {{count}} giorno",
  "date_range_min_days_error_other": "L'intervallo deve essere di almeno {{count}} giorni",
  "past_dates": "La data non può essere antecedente a {{minDate}}",
  "future_dates": "La data non può essere successiva a {{maxDate}}",
  "signature_placeholder_text": "Firma all'interno di questa casella.<br/> Usa il dito.<br/> Tocca per iniziare.",
  "open_devices_camera": "Aprire la fotocamera del dispositivo",
  "place_document_inside_frame": "Posizionare il documento all'interno della cornice",
  "close_other_application_that_may_be_using_your_camera": "Chiudere altre applicazioni che potrebbero utilizzare la fotocamera",
  "if_you_use_external_camera_disconnect_and_reconnect": "Se si utilizza una telecamera esterna, scollegarla e ricollegarla.",
  "close_the_browser_re_open_it": "Chiudere il browser e riaprirlo",
  "camera_errors": {
    "experiencing_camera_issues": "Problemi con la fotocamera?",
    "chekin_cant_use_your_camera": "Chekin non può usare la macchina fotografica",
    "please_try_a_different_browser": "La fotocamera non funziona con questo browser. Provi ad aprire il link in un altro browser.",
    "permissions_denied": "Autorizzazione negata",
    "camera_permissions_denied": "La fotocamera non si apre? Assicurarsi di autorizzare il browser a utilizzare la fotocamera.",
    "no_camera_device_found": "Non è stato trovato alcun dispositivo di ripresa. Collegare una fotocamera.",
    "constraints_camera_error": "I vincoli non possono essere soddisfatti dai dispositivi disponibili.",
    "safari_camera_error": "Safari non è riuscito a soddisfare i requisiti della telecamera",
    "try_chrome_or_firefox": "Provare con Chrome o Firefox"
  },
  "clear": "Libero",
  "show_less": "Mostra meno",
  "show_more": "Mostra di più",
  "tap_here_to_sign": "Toccare qui per firmare",
  "click_here_to_sign": "Clicca qui per firmare",
  "prefix": "Prefisso",
  "prefix_required": "Il prefisso è richiesto",
  "reset": "Reset",
  "show_password": "Mostra password",
  "hide_password": "Nascondere la password",
  "increment": "Incremento",
  "decrement": "Decremento",
  "create_option": "Creare \"{{input}}\"",
  "year_out_of_range": "L'anno deve essere compreso tra {{min}} e {{max}}",
  "clear_date": "Data di cancellazione",
  "select_date": "Selezionare la data",
  "draw_signature_here": "Metti qui la tua firma",
  "signature_hint": "Usa il mouse o il dito",
  "clear_signature": "Firma chiara",
  "draw_signature_here_mobile": "Firma qui",
  "signature_hint_mobile": "Usa il dito",
  "camera_access_needed": "È necessario l'accesso alla fotocamera",
  "camera_access_needed_text": "Consenti l'accesso alla fotocamera per scattare la foto. Se l'accesso è bloccato, abilita la fotocamera nelle impostazioni del browser, quindi riprova.",
  "dialog": "Dialogo"
}
